/* eslint-disable id-length */
export const uploadImagePositions = ['left', 'right', 'back', 'front'];

export const removeBackgrounds = {
  T: true,
  F: false,
};

export const imageSizes = {
  L: 'Large',
  M: 'Medium',
  S: 'Small',
};

export const imagePlacements = {
  T: 'North',
  M: 'Center',
  B: 'South',
};

export const imagePlacementValues = {
  T: 'Top',
  M: 'Middle',
  B: 'Bottom',
};

export const defaultUploadImages = [
  {
    id: 1,
    uploadImageTabName: 'Front',
    uploadedImageFileName: null,
    uploadedImageUrl: null,
    showUploadRemoveButton: false,
    toggleRemoveBackground: false,
    enableRemoveBackground: false,
    isImageLoading: false,
    imageSize: 'Large',
    imagePlacement: 'Center',
    imagePlacementValue: 'Middle',
  },
  {
    id: 2,
    uploadImageTabName: 'Left',
    uploadedImageFileName: null,
    uploadedImageUrl: null,
    showUploadRemoveButton: false,
    toggleRemoveBackground: false,
    enableRemoveBackground: false,
    isImageLoading: false,
    imageSize: 'Large',
    imagePlacement: 'Center',
    imagePlacementValue: 'Middle',
  },
  {
    id: 3,
    uploadImageTabName: 'Back',
    uploadedImageFileName: null,
    uploadedImageUrl: null,
    showUploadRemoveButton: false,
    toggleRemoveBackground: false,
    enableRemoveBackground: false,
    isImageLoading: false,
    imageSize: 'Large',
    imagePlacement: 'Center',
    imagePlacementValue: 'Middle',
  },
  {
    id: 4,
    uploadImageTabName: 'Right',
    uploadedImageFileName: null,
    uploadedImageUrl: null,
    showUploadRemoveButton: false,
    toggleRemoveBackground: false,
    enableRemoveBackground: false,
    isImageLoading: false,
    imageSize: 'Large',
    imagePlacement: 'Center',
    imagePlacementValue: 'Middle',
  },
];

export const vestUploadImages = [
  {
    id: 1,
    uploadImageTabName: 'Front',
    uploadedImageFileName: null,
    uploadedImageUrl: null,
    showUploadRemoveButton: false,
    toggleRemoveBackground: false,
    enableRemoveBackground: false,
    isImageLoading: false,
    logoColors: 1,
  },
  {
    id: 3,
    uploadImageTabName: 'Back',
    uploadedImageFileName: null,
    uploadedImageUrl: null,
    showUploadRemoveButton: false,
    toggleRemoveBackground: false,
    enableRemoveBackground: false,
    isImageLoading: false,
    logoColors: 1,
  },
];
